import { render, staticRenderFns } from "./KintaiListTable.vue?vue&type=template&id=63ea83f9&"
import script from "./KintaiListTable.vue?vue&type=script&lang=ts&"
export * from "./KintaiListTable.vue?vue&type=script&lang=ts&"
import style0 from "./KintaiListTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports